import {useAccountFeatures} from "../../../hooks/accountFeatures";

/** One switch, because the prototype's two surfaces link into each other and cannot be shown apart. */
export const useOeDemo = (): boolean => useAccountFeatures().has("OperatingEffectivenessDemo");
